import axios from 'axios';
import withDecrypt from '../../../src/withDecrypt';

async function fetchAPI(query, accessToken) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    headers: { accesstoken: accessToken },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function _updateScreen(screen_name, screen_desc, andor, formula, inputText, columns, accessToken) {
  // code: \"${item?.code?.replace(/`/g, '')}\",
  const removeQuotes = (str) => str.replace(/"/g, "");
  const objectToString = (obj) =>
    `{
    andor: ${removeQuotes(obj.andor)},
    metricsCriteria: [
      ${obj.metricsCriteria?.map(
        (item) =>
          (item.code === `\`industry\`` || item.code === `\`sector\``) ?
            `{
            code: \"${item?.code}\",
            condition: ${removeQuotes(item.condition)},
            value: "\\"${item.value}\\""
          }`:
            `{
            code: "${item.code}",
            condition: ${removeQuotes(item.condition)},
            value: "${item.value}"
          }`
      )
      .join(",\n")}
    ]
  }`;
  const formulaString = `[${formula?.map(objectToString).join(",\n")}]`;
  const data = await fetchAPI(
    `
    mutation {
      updateScreen(
        screen_name: "${screen_name}"
        screen_desc: "${screen_desc}"
        andor: ${andor}
        formula: ${formulaString}
        inputText: ${JSON.stringify(inputText)}
        columns: "${columns}"
      ) {
        screen_name
      }
    }
    `, accessToken
  )
  return data
}

